import React from 'react';
import ThreadsLoadingSpinner from 'plaid-threads/LoadingSpinner'; // eslint-disable-line

const LoadingSpinner: React.FC = () => {
  return <ThreadsLoadingSpinner />;
};

export default LoadingSpinner;
